<template>
  <generic-modal
    size="large"
    :title="$t('nvidia bundle configuration')"
    icon="settings"
    image="/images/icons/nvidia.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
  >
    <div class="description">
      <div class="ui two item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="cards"
          ><i class="cubes icon"></i> {{ $t("graphic cards") }}</a
        >
        <a class="item" data-tab="stores"
          ><i class="store icon"></i>{{ $t("stores") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="cards">
        <!-- <graphic-cards /> -->
      </div>
      <div class="ui bottom attached tab segment" data-tab="stores">
        <!-- <stores /> -->
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
// import GraphicCards from "./GraphicCards.vue";
// import Stores from "./Stores.vue";
// import GenericContainer from "@/components/GenericContainer";
// import { local_api, error_toast, warning_toast } from "@/utils";

export default {
  name: "NvidiaBundleConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    // GraphicCards,
    // Stores,
    // GenericContainer,
  },
  computed: {},
  data() {
    return {
      setup: {
        stores: [],
        graphic_cards: [],
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    // finished() {
    //   let vm = this;
    //   return new Promise(function(resolve, reject) {
    //     // let settings = vm.settings;
    //     local_api(vm, "post", "/nvidia_bundle/do-save-configuration", {
    //       s: vm.setup,
    //     })
    //       .then(() => {
    //         resolve();
    //       })
    //       .catch((err) => {
    //         reject(err);
    //       });
    //   });
    // },
  },
  mounted() {
    let vm = this;
    // local_api(this, "post", "/nvidia_bundle/do-get-configuration")
    //   .then((conf) => {
    //     if (conf) vm.setup = conf;
    //     else warning_toast("no configuration has been seted yet");
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {},
};
</script>
